
class CapSubmitNewStudent {
  constructor(config) {
    this.config = config
  }

  // eslint-disable-next-line
  checkPermission(options = {}) {
    return false
  }
}

function key() {
  return 'submit_new_student'
}

function create(config) {
  return new CapSubmitNewStudent(config)
}

export default {
  key,
  create,
}
